/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExistingVipDiscountsRequest } from '../../models/existing-vip-discounts-request';
import { ExistingVipDiscountsResponse } from '../../models/existing-vip-discounts-response';

export interface FindExistingVipDiscountCombinations$Params {
      body: ExistingVipDiscountsRequest
}

export function findExistingVipDiscountCombinations(http: HttpClient, rootUrl: string, params: FindExistingVipDiscountCombinations$Params, context?: HttpContext): Observable<StrictHttpResponse<ExistingVipDiscountsResponse>> {
  const rb = new RequestBuilder(rootUrl, findExistingVipDiscountCombinations.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExistingVipDiscountsResponse>;
    })
  );
}

findExistingVipDiscountCombinations.PATH = '/discounts/vip/existing-combinations';
